import { render, staticRenderFns } from "./ViewBulkClaim.vue?vue&type=template&id=365fbf21&scoped=true&lang=pug&"
import script from "./ViewBulkClaim.vue?vue&type=script&lang=js&"
export * from "./ViewBulkClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365fbf21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
